import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import useForm from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';

const ListAuthor = (props) => {
  const { displayOptions } = props;
  const {
    attributes,
    actions,
    listAuthor,
    findAllAuthor,
    totalPages,
    // currentPage,
    // setCurrentPage,
    loading,
    // setOrder,
    // order,
    // setKeyword,
    // keyword,
    // limit,

    query,
    setQuery,
    isDisplayed,
    setIsDisplayed,
  } = useForm(displayOptions);

  const { t, i18n } = useTranslation();

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('author.title.list')} subtitle={t('author.subTitle')} className="text-sm-left" />
      </Row>

      <Row>
        <Col>
          <Card small className="mb-4">
            <Table
              attributes={attributes}
              actions={actions}
              data={listAuthor}
              loading={loading}
              search={findAllAuthor}
              numberOfPage={totalPages}
              query={query}
              isDisplayed={isDisplayed}
              setIsDisplayed={setIsDisplayed}
              textButton={displayOptions.addButton && t('author.add')}
              linkButton={displayOptions.addButton && '/author/add'}
              pdfTitle="Liste des auteurs"
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ListAuthor;
